var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1121 5.97921L8.12964 11.9617C7.92747 12.1639 7.65246 12.2762 7.36656 12.2734L4.87343 12.2489C4.30009 12.2432 3.83426 11.7844 3.81989 11.2112L3.75908 8.78627C3.75177 8.49482 3.86433 8.21313 4.07048 8.00698L10.1052 1.97227C10.5208 1.55662 11.1947 1.55662 11.6104 1.97227L14.1121 4.474C14.5278 4.88965 14.5278 5.56356 14.1121 5.97921Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 14.1666H4.24999C3.85879 14.1666 3.54166 14.4838 3.54166 14.875C3.54166 15.2662 3.85879 15.5833 4.24999 15.5833H13.4583C13.8495 15.5833 14.1667 15.2662 14.1667 14.875C14.1667 14.4838 13.8495 14.1666 13.4583 14.1666Z",
    fill: "#ADB5BD"
  })));
};
export default SvgEdit;